import { getFormValues } from 'redux-form';
import { LOGIN_FORM_NAME } from 'Common/FormEnum';

export const loginFormSelector = getFormValues(LOGIN_FORM_NAME);
export const getLoginFormValues = state => loginFormSelector(state);



// WEBPACK FOOTER //
// ./src/pages/login/state/selectors.js